import styled from "styled-components";
import React, { useEffect, useRef, useState } from "react";
import { localforageGetItem } from 'oautils/oaForageUtils';
import { GET_FILE_UPLOAD } from "api/ApiConstants";
import FlightTicketItinerary from "./FlightTicketItinerary";
import FlightTicketPassenger from "./FlightTicketPassenger";
import FlightTicketGstDetails from "./FlightTicketGstDetails";
import FlightTicketFare from "./FlightTicketFare";
import FlightTicketContactDetails from "./FlightTicketContactDetails";
import FlightTicketAdditionalInfo from "./FlightTicketAdditionalInfo";
import { useTheme } from "@material-ui/core";

const FlightTicketResult = (props) => {
    const isMounted = useRef(false);
    const theme = useTheme();
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState("0.00");
    const [basefare, setBasefare] = useState(0.00);
    const [taxes, setTaxes] = useState(0.00);
    const [userId, setUserId] = useState(0);
    const [total, setTotal] = useState(0.00);
    const [gst, setGst] = useState(0.00);
    const [mealbaggage, setMealBaggage] = useState(0.00);

    const [baggage, setBaggage] = useState("");
    const [meal, setMeal] = useState("");
    const [seat, setSeat] = useState("");

    const getRefundStatus = (data) => {
        const refund = data.includes("Refundable");
        const nRefund = data.includes("Non Refundable");
        if (refund)
          return "Refundable";
        else if (nRefund)
          return "Non Refundable";
        return "Refundable";
      }
    
    const getClass = (data) => {
        var n = data.indexOf("Booking Class : "); // 16 character string
        n = n + 16;
        return data.substring(n, n + 1);
    };

    const getTimeDiffrence = (fromDataTime, toDataTime) => {
        var date1 = new Date(fromDataTime);
        var date2 = new Date(toDataTime);

        var diff = date2.getTime() - date1.getTime();

        var msec = diff;
        var hh = Math.floor(msec / 1000 / 60 / 60);
        msec -= hh * 1000 * 60 * 60;
        var mm = Math.floor(msec / 1000 / 60);
        msec -= mm * 1000 * 60;
        var ss = Math.floor(msec / 1000);
        msec -= ss * 1000;

        return hh + ":" + mm;
    };

    const initializeTicketData = () => {
        let filename = "";

        filename = props.data?.agentInfo && props.data.agentInfo.agentLogo != "NA" ? props.data.agentInfo.agentLogo : "company_logo.png";

        if (props.state?.isPerPassenger) {
            let paxCount = props.data.passengers?.length;

            let _airFare = props.passenger.type === "Adult" ? props.data.adultFareBreakUpOneWay.airFare : (props.passenger.type === "Child" ? props.data.childFareBreakUpOneWay.airFare : props.data.infantFareBreakUpOneWay.airFare);
            let _airFare_return = props.passenger.type === "Adult" ? props.data.adultFareBreakUpReturn.airFare : (props.passenger.type === "Child" ? props.data.childFareBreakUpReturn.airFare : props.data.infantFareBreakUpReturn.airFare);

            let _taxes = props.passenger.type === "Adult" ? props.data.adultFareBreakUpOneWay.taxes : (props.passenger.type === "Child" ? props.data.childFareBreakUpOneWay.taxes : props.data.infantFareBreakUpOneWay.taxes);
            let _taxes_return = props.passenger.type === "Adult" ? props.data.adultFareBreakUpReturn.taxes : (props.passenger.type === "Child" ? props.data.childFareBreakUpReturn.taxes : props.data.infantFareBreakUpReturn.taxes);

            let _gst = props.passenger.type === "Adult" ? props.data.adultFareBreakUpOneWay.otherTaxes !== null && props.data.adultFareBreakUpOneWay.otherTaxes.K3 : (props.passenger.type === "Child" ? props.data.childFareBreakUpOneWay.otherTaxes !== null && props.data.childFareBreakUpOneWay.otherTaxes.K3 : props.data.infantFareBreakUpOneWay.otherTaxes !== null && props.data.infantFareBreakUpOneWay.otherTaxes.K3);

            let _gst_return = 0;
            let noOfJourney = 1 * props.data.passengers.length;


            if (props.data.adultFareBreakUpReturn.otherTaxes && props.data.adultFareBreakUpReturn.otherTaxes !== null) {
                _gst_return = props.passenger.type === "Adult" ? props.data.adultFareBreakUpReturn.otherTaxes.K3 : (props.passenger.type === "Child" ? props.data.childFareBreakUpReturn.otherTaxes.K3 : props.data.infantFareBreakUpReturn.otherTaxes.K3);

                noOfJourney = 2 * props.data.passengers.length;
            }


            let _mealbaggage = 0;
            let _mealbaggage_return = 0;

            let _meal = "";
            let _meal_return = "";

            let _baggage = "";
            let _baggage_return = "";

            let _seat = "";
            let _seat_return = "";

            if (props.journeyType === 'return') {
                _airFare = 0;
                _taxes = 0;
                _gst = 0;
                _mealbaggage = 0;
                _meal = "";
                _baggage = "";
                _seat = "";


                _mealbaggage_return += parseInt(props.passenger.return_meal);
                _mealbaggage_return += parseInt(props.passenger.return_baggage);
                _mealbaggage_return += parseInt(props.passenger.return_seat);

                setMealBaggage(parseInt(_mealbaggage_return));

                _meal_return = props.passenger.return_meal_description;
                _baggage_return = props.passenger.return_baggage_description;
                _seat_return = props.passenger.return_seat_description;

                setMeal(_meal_return);
                setBaggage(_baggage_return);
                setSeat(_seat_return);

                setBasefare(parseInt(props.data.flightSummary?.returnBaseFare) > 0 ? parseInt(props.data.flightSummary?.returnBaseFare)/paxCount : 0);
                setTaxes(parseInt(props.data.flightSummary?.returnTaxNFees) > 0 ? parseInt(props.data.flightSummary?.returnTaxNFees)/paxCount : 0);
                setGst(parseInt(props.data.flightSummary?.returnGST) > 0 ? parseInt(props.data.flightSummary?.returnGST)/paxCount : 0);
                setMealBaggage(parseInt(props.data.flightSummary?.returnMealBeggageSeatNMisc) > 0 ? parseInt(props.data.flightSummary?.returnMealBeggageSeatNMisc)/paxCount : 0);

                setTotal(parseInt(props.data.flightSummary?.returnTotal) > 0 ? parseInt(props.data.flightSummary?.returnTotal)/paxCount : 0);

            } else if (props.journeyType === 'onward') {
                _airFare_return = 0;
                _taxes_return = 0;
                _gst_return = 0;
                _mealbaggage_return = 0;
                _meal_return = "";
                _baggage_return = "";
                _seat_return = "";

                _mealbaggage += parseInt(props.passenger.onward_meal);
                _mealbaggage += parseInt(props.passenger.onward_baggage);
                _mealbaggage += parseInt(props.passenger.onward_seat);
                setMealBaggage(parseInt(_mealbaggage));


                _meal = props.passenger.onward_meal_description;
                _baggage = props.passenger.onward_baggage_description;
                _seat = props.passenger.onward_seat_description;
                setMeal(_meal);
                setBaggage(_baggage);
                setSeat(_seat);

                setBasefare(parseInt(props.data.flightSummary?.onwardBaseFare) > 0 ? parseInt(props.data.flightSummary?.onwardBaseFare)/paxCount : 0);
                setTaxes(parseInt(props.data.flightSummary?.onwardTaxNFees) > 0 ? parseInt(props.data.flightSummary?.onwardTaxNFees)/paxCount : 0);
                setGst(parseInt(props.data.flightSummary?.onwardGST) > 0 ? parseInt(props.data.flightSummary?.onwardGST)/paxCount : 0);
                setMealBaggage(parseInt(props.data.flightSummary?.onwardMealBeggageSeatNMisc) > 0 ? parseInt(props.data.flightSummary?.onwardMealBeggageSeatNMisc)/paxCount : 0);

                setTotal(parseInt(props.data.flightSummary?.onwardTotal) > 0 ? parseInt(props.data.flightSummary?.onwardTotal)/paxCount : 0);
            }
        } else if (props.journeyType === 'onward') {
            let noOfJourney = 1;
            if (props.data.adultFareBreakUpReturn.otherTaxes) {
                noOfJourney = 2;
            }

            let _airFare = 0;
            let _taxes = 0;
            let _gst = 0;
            let _meal = "";
            let _baggage = "";
            let _seat = "";
            let _mealbaggage = 0;
            props.data.passengers.map((passenger, index) => {
                _airFare += parseInt(passenger.type === "Adult" ? props.data.adultFareBreakUpOneWay.airFare : (passenger.type === "Child" ? props.data.childFareBreakUpOneWay.airFare : props.data.infantFareBreakUpOneWay.airFare));
                _taxes += parseInt(passenger.type === "Adult" ? props.data.adultFareBreakUpOneWay.taxes : (passenger.type === "Child" ? props.data.childFareBreakUpOneWay.taxes : props.data.infantFareBreakUpOneWay.taxes));
                if (props.data.adultFareBreakUpOneWay.otherTaxes && props.data.adultFareBreakUpOneWay.otherTaxes !== null && parseInt(passenger.type === "Adult" ? props.data.adultFareBreakUpOneWay.otherTaxes.K3 : (passenger.type === "Child" ? props.data.childFareBreakUpOneWay.otherTaxes !== null && props.data.childFareBreakUpOneWay.otherTaxes.K3 : props.data.infantFareBreakUpOneWay.otherTaxes !== null && props.data.infantFareBreakUpOneWay.otherTaxes.K3)) > 0) {
                    _gst += parseInt(passenger.type === "Adult" ? props.data.adultFareBreakUpOneWay.otherTaxes !== null && props.data.adultFareBreakUpOneWay.otherTaxes.K3 : (passenger.type === "Child" ? props.data.childFareBreakUpOneWay.otherTaxes !== null && props.data.childFareBreakUpOneWay.otherTaxes.K3 : props.data.infantFareBreakUpOneWay.otherTaxes !== null && props.data.infantFareBreakUpOneWay.otherTaxes.K3));
                }

                _mealbaggage += parseInt(passenger.onward_meal);
                _mealbaggage += parseInt(passenger.onward_baggage);
                _mealbaggage += parseInt(passenger.onward_seat);

                _meal = passenger.onward_meal_description;
                _baggage = passenger.onward_baggage_description;
                _seat = passenger.onward_seat_description;
            });

            let _total = parseInt(_airFare) + parseInt(_taxes) + parseInt(_mealbaggage);

            setBasefare(parseInt(props.data.flightSummary?.onwardBaseFare));
            setTaxes(parseInt(props.data.flightSummary?.onwardTaxNFees));
            setGst(parseInt(props.data.flightSummary?.onwardGST));
            setMealBaggage(parseInt(props.data.flightSummary?.onwardMealBeggageSeatNMisc));

            setMeal(_meal);
            setBaggage(_baggage);
            setSeat(_seat);

            setTotal(parseInt(props.data.flightSummary?.onwardTotal));

        } else if (props.journeyType === 'return') {
            let noOfJourney = 2;

            let _airFare_return = 0;
            let _taxes_return = 0;
            let _gst_return = 0;

            let _meal_return = "";
            let _baggage_return = "";
            let _seat_return = "";
            let _mealbaggage_return = 0;
            props.data.passengers.map((passenger, index) => {
                _airFare_return += parseInt(passenger.type === "Adult" ? props.data.adultFareBreakUpReturn.airFare : (passenger.type === "Child" ? props.data.childFareBreakUpReturn.airFare : props.data.infantFareBreakUpReturn.airFare));
                _taxes_return += parseInt(passenger.type === "Adult" ? props.data.adultFareBreakUpReturn.taxes : (passenger.type === "Child" ? props.data.childFareBreakUpReturn.taxes : props.data.infantFareBreakUpReturn.taxes));
                if (props.data.adultFareBreakUpReturn.otherTaxes && parseInt(passenger.type === "Adult" ? props.data.adultFareBreakUpReturn.otherTaxes.K3 : (passenger.type === "Child" ? props.data.childFareBreakUpReturn.otherTaxes.K3 : props.data.infantFareBreakUpReturn.otherTaxes.K3)) > 0) {
                    _gst_return += parseInt(passenger.type === "Adult" ? props.data.adultFareBreakUpReturn.otherTaxes.K3 : (passenger.type === "Child" ? props.data.childFareBreakUpReturn.otherTaxes.K3 : props.data.infantFareBreakUpReturn.otherTaxes.K3));
                }
                _mealbaggage_return += parseInt(passenger.return_meal);
                _mealbaggage_return += parseInt(passenger.return_baggage);
                _mealbaggage_return += parseInt(passenger.return_seat);


                _meal_return = passenger.return_meal_description;
                _baggage_return = passenger.return_baggage_description;
                _seat_return = passenger.return_seat_description;
            });

            let _total_return = parseInt(_airFare_return) + parseInt(_taxes_return) + parseInt(_mealbaggage_return);

            setBasefare(parseInt(props.data.flightSummary?.returnBaseFare));
            setTaxes(parseInt(props.data.flightSummary?.returnTaxNFees));
            setGst(parseInt(props.data.flightSummary?.returnGST));
            setMealBaggage(parseInt(props.data.flightSummary?.returnMealBeggageSeatNMisc));
            setMeal(_meal_return);
            setBaggage(_baggage_return);
            setSeat(_seat_return);

            setTotal(parseInt(props.data.flightSummary?.returnTotal));
        } else {
            let _airFare = props.data.flightSummary.basefare;
            let _taxes = props.data.flightSummary.taxes;
            let _managementFee = props.data.flightSummary.surcharge
            let _total = _airFare + _taxes + _managementFee;

            let _gst = props.data.flightSummary.gst;

            setBasefare(props.data.flightSummary?.onwardBaseFare);
            setTaxes(props.data.flightSummary?.onwardTaxNFees);
            setGst(parseInt(props.data.flightSummary?.onwardGST));
            setTotal(parseInt(props.data.flightSummary?.onwardTotal));
            setMealBaggage(parseInt(props.data.flightSummary?.onwardMealBeggageSeatNMisc));
        }
    };

    useEffect(() => {
        isMounted.current = true;

        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        if(isMounted.current) {
            localforageGetItem('user-details', function (err, value) {
                setUserId(value.userId);
            });
        }
    }, [isMounted.current]);

    useEffect(() => {
        if(props.data && props.state && userId) {
            initializeTicketData();
        }
    }, [userId, props])

    return(
        <div className="flight-ticket-result-root">
            <div className="flex-box justify-space-between ticket-row corp-identity-row">
                <div className="ticket-col logo-col">
                    {props.data && props.data.agentInfo && userId &&
                        props.data.agentInfo.agentLogo != "" &&
                        props.data.agentInfo.agentLogo != "NA" &&
                        props.data.agentInfo.agentLogo != "N/A" &&
                        props.data.agentInfo.agentLogo != null ?
                        <img className="logo" src={
                            GET_FILE_UPLOAD + "?fileName=" + props.data.agentInfo.agentLogo + "&type=AGENT_LOGO&loggedInUserId=" + userId
                        }/>
                        : props.appconst.defaultCompanyLogo ?
                        <img className="logo" src={props.appconst?.brandUrl} /> : ""
                    }
                </div>
                <div className="ticket-col pnr-col">
                    <h3>PNR: {props?.journeyType === "return" ? props.data?.retunPnrNo : props.data?.onwardPnrNo}</h3>
                </div>
                <div className="ticket-col ticket-info-col">
                    <p>Booking Date: {props.data?.bookingDate}</p>
                    <p>Booking Id: {props.data?.bookingRef}</p>
                    {/* <p>{props?.journeyType === "return" ? props.data?.isReturnRefundable : props.data?.isOnwardRefundable}</p> */}
                    <p>{props.isStatusLoading === false ? (props.data.bookingStatus === 'SUCCESSCan' ? 'Cancelled' : (props.data.bookingStatus === 'SuccessTkd' ? 'Confirmed' : 'Under Process')) : 'updating ...'}</p>
                </div>
            </div>
            <div className="flex-box justify-space-between ticket-row ticket-notification-row">
                <div className="ticket-col ticket-notification-col w100p" style={{width: "100%"}}>
                    * Please verify timings & terminal info with airline before boarding
                </div>
            </div>
            {props.journey && props.journey.map((dataItin, index) =>
                <div className="itin-row-container" key={index}>
                    <FlightTicketItinerary
                        dataItin={dataItin}
                        cabinType={props.data.flightSummary?.cabinType}
                        fareType={props.data?.requestedFareType}
                    />
                </div>
            )}
            <div className="flex-box justify-space-between ticket-row traveller-details-row">
                <div className="ticket-col section-details-header-col w100p">
                    <h2>Traveller Details</h2>
                </div>
                <div className="ticket-col traveller-details-table-col w100p">
                    <FlightTicketPassenger
                        isPerPassenger={props.state?.isPerPassenger}
                        passengers={props.data?.passengers}
                        passenger={props.state?.isPerPassenger && props.passenger || null}
                        journeyType={props.journeyType}
                        deliveryAddress={props.data?.deliveryAddress}
                        emailId={props.data?.emailId}
                    />
                </div>
            </div>
            {!props.state?.isGSTHide && props.data?.gstInfo && props.data.gstInfo?.gstNo &&
                <div className="flex-box justify-space-between ticket-row gst-details-row">
                    <div className="ticket-col section-details-header-col w100p">
                        <h2>GST Details</h2>
                    </div>
                    <div className="ticket-col gst-details-table-col w100p">
                        <FlightTicketGstDetails
                            gstInfo={props.data?.gstInfo}
                        />
                    </div>
                </div>
            }
            <div className="flex-box ticket-row fare-details-row-row justify-space-between">
                {(!props.state?.isFareHide && basefare != null) &&
                    <div className="ticket-col w40p" style={{width: "48%"}}>
                        <div className="flex-box ticket-row fare-details-row">
                            <div className="ticket-col section-details-header-col w100p">
                                <h2>Fare Summary</h2>
                            </div>
                        </div>
                        <div className="flex-box ticket-row fare-details-row">
                            <div className="ticket-col fare-details-table-col w100p" style={{width: "100%"}}>
                                <FlightTicketFare
                                    basefare={basefare}
                                    taxes={taxes}
                                    gst={gst}
                                    mealbaggage={mealbaggage}
                                    total={total}
                                />
                            </div>
                        </div>
                    </div>
                }
                <div className="ticket-col w40p" style={{width: "48%"}}>
                    <div className="flex-box ticket-row contact-details-row">
                        <div className="ticket-col section-details-header-col w100p"></div>
                    </div>
                    <FlightTicketContactDetails
                        data={props.data}
                        journeyType={props.journeyType}
                    />
                </div>
            </div>
            <div className="ticket-row additional-info-row">
                <div className="ticket-col additional-info-col w100p">
                    <FlightTicketAdditionalInfo/>
                </div>
            </div>
            <style>{RootStylesFtr(theme, props.appconst)}</style>
        </div>
    );
};

export default FlightTicketResult;

// DON'T INCLUDE RESPONSIVE STYLES IN THIS COMPONENT - RESPONSIVE RULES MUST BE ADDED TO FlightTicket component
const RootStylesFtr = (theme, appconst) => `
.flight-ticket-result-root {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
}

.flight-ticket-result-root h3 {
    font-family: ${theme.palette.font.secondary};
}

.itin-row-container {
    width: 100%;
}

.flight-ticket-result-root p {
    margin-block-start: 0;
    margin-block-end: 0;
    line-height: 1.5;
    color: ${theme.palette.text.dark};
    font-family: ${theme.palette.font.secondary};
    font-weight: 500;
}

.ticket-row {
    flex-wrap: wrap;
}
    
.ticket-row.ticket-notification-row {
    padding: 10px 0;
}

.ticket-row .ticket-itin-row {
    border-top: solid 1px ${theme.palette.background.lightGrayFaded};
    padding: 10px;
}

.logo-col img {
    width: unset;
    height: 100px;
}

.section-details-header-col {
    min-height: 50px;
}

.section-details-header-col h2 {
    margin-block-start: 1em;
    margin-block-end: 0.5em;
    font-weight: 600;
    font-size: 16px;
    color: ${theme.palette.text.dark};
    font-family: ${theme.palette.font.secondary};
}

.ticket-info-col p {
    text-align: right;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.6;
}

.ticket-notification-col {
    text-align: right;
    font-weight: 600;
    font-size: 14px;
    font-style: italic;
    font-family: ${theme.palette.font.secondary};
}

.carrier-identity-col {
    width: 260px;
    padding: 10px;
    box-sizing: border-box;
}

.carrier-identity-col .carrier-icon {
    height: 35px;
    padding-top: 5px;
    padding-right: 5px;
}

.carrier-identity-col .carrier-name-number .carrier-number {
    font-weight: bold;
    font-size: 15px;
}

.carrier-identity-col .carrier-name-number .carrier-name {
    font-size: 12px;
    font-weight: 500;
}

.itin-col {
    width: 150px;
}

.itin-col .itin-container {
    width: 100%;
    padding: 10px;
    border: solid 2px ${theme.palette.background.lightGrayFaded};
}

.itin-col .itin-container p {
    text-align: center;
    line-height: 1.5;
}

.itin-col .itin-container .airport-text {
    font-weight: bold;
}
    
.itin-col .itin-container .date-text {
    font-size: 13px;
    font-weight: 500;
}
        

.itin-col .itin-container .terminal-text {
    font-size: 12px;
    font-weight: 400;
}

.itin-col .itin-container .airport-desc-text {
    font-size: 10px;
    font-weight: 400;
    height: 30px;
}

.journey-duration-col {
    width: 150px;
    padding: 10px;
}

.journey-duration-col p {
    text-align: center;
    font-size: 12px;
}

.addon-info-col {
    gap: 20px;
}

.addon-info-col p {
    font-size: 12px;
}

.addon-info-col .add-on-label {
    font-weight: 600;
    font-family: ${theme.palette.font.secondary};
}  

.addon-info-col .add-on-value {
    font-weight: 500;
}

.traveller-details-table, .gst-details-table, .fare-details-table, .contact-details-table {
    border-spacing: 0;
    width: 100%;
    border: solid 1px ${theme.palette.background.lightGrayFaded};
}

.traveller-details-table, .gst-details-table {
    min-width: 750px;
}

.flight-ticket-result-root th {
    background: ${appconst?.primaryColorTicket ? theme.palette.primary.main : theme.palette.background.lightGrayFaded};
    border-right: solid 1px ${theme.palette.background.lightGrayFaded};
    font-size: 12px;
    font-weight: 600;
    line-height: 1.5;
    padding: 2px;
    color: ${appconst?.primaryColorTicket ? theme.palette.primary.contrastText : theme.palette.text.dark};
    font-family: ${theme.palette.font.secondary};
}

.flight-ticket-result-root th:last-child {
    border-right: none;
}

.flight-ticket-result-root td {
    border-top: solid 1px ${theme.palette.background.lightGrayFaded};
    border-right: solid 1px ${theme.palette.background.lightGrayFaded};
    font-size: 12px;
    font-weight: 400;
    padding: 5px 5px 2px;
    text-align: center;
    vertical-align: top;
    color: ${theme.palette.text.dark};
    text-transform: capitalize;
    font-family: ${theme.palette.font.secondary};
}

.flight-ticket-result-root td:last-child {
    border-right: none;
}

.gst-details-table-container td, .fare-details-table td {
    padding: 10px 5px;
}

.fare-details-table th {
    padding: 10px 5px;
}

.fare-details-table .img-grid {
    display: flex;
    justify-content: center;
}

.flight-ticket-result-root th.text-align-left, .flight-ticket-result-root td.text-align-left {
    text-align: left;
}

.flight-ticket-result-root th.text-align-right, .flight-ticket-result-root td.text-align-right {
    text-align: right;
}

.contact-details-table-col {
    padding-bottom: 20px;
}

.contact-details-table {
    width: 100%;
}

.contact-details-table .contact-img-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
}

.contact-details-table .contact-img-wrapper img {
    height: 18px;
}
    
.contact-details-table td {
    line-height: 1.6;
}   

.contact-details-table .email-span {
    text-transform: lowercase;
}

.flight-ticket-additional-info {
    padding: 15px 0;
}

.flight-ticket-additional-info .terms-and-conditions {
    margin-bottom: 40px;
}

.flight-ticket-additional-info .terms-and-conditions h3 {
    text-align: center;
    font-weight: 500;
    text-decoration: underline;
    color: ${theme.palette.text.dark};
    font-family: ${theme.palette.font.secondary};
}

.flight-ticket-additional-info .terms-and-conditions p {
    font-size: 11px;
    line-height: 1.8;
    font-family: ${theme.palette.font.secondary};
}

.flight-ticket-additional-info .do-and-do-nots img {
    width: 100%;
}

.pax-contact-col {
    background-color: ${theme.palette.background.lightGrayFaded};
}
`;
